"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePendingMedicalRecordsSpecialist = void 0;
const tslib_1 = require("tslib");
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const moment_1 = tslib_1.__importDefault(require("moment"));
const keyFactory_1 = require("../keyFactory");
/** Select de React-Query para filtrar sólo por los que todavía no pasaron */
function getPendingMedicalRecords(medicalRecords) {
    return medicalRecords.filter(medicalRecord => {
        const isFuture = (0, moment_1.default)(medicalRecord.attentionDate, "YYYY-MM-DD").isAfter((0, moment_1.default)().subtract(1, "day"));
        return (medicalRecord.mr.dt_cierre === null && isFuture);
    });
}
function usePendingMedicalRecordsSpecialist(firestore, uid, options, useQueryOptions) {
    const medicalRecordsRef = (0, firestore_2.collection)(firestore, `user/${uid}`, "medical_records");
    const queryRef = (0, firestore_2.query)(medicalRecordsRef, (0, firestore_2.where)("att_category", "==", "MI_ESPECIALISTA"));
    return (0, firestore_1.useFirestoreQueryData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "medicalRecordsSpecialist",
        path: `user/${uid}/medical_records`
    }, [uid]), queryRef, options, {
        ...useQueryOptions,
        select: (medicalRecords) => {
            if (useQueryOptions?.select) {
                const result = getPendingMedicalRecords(medicalRecords);
                return useQueryOptions.select(result);
            }
            return getPendingMedicalRecords(medicalRecords);
        }
    });
}
exports.usePendingMedicalRecordsSpecialist = usePendingMedicalRecordsSpecialist;
exports.default = usePendingMedicalRecordsSpecialist;
